import React from 'react'
import ContactWidget from '../components/ContactWidget'
import Footer from '../components/Footer'
import Navbar from '../components/navBar'

function Articles() {
    return (
        <div className="min-h-screen bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 transition-colors duration-300">
            <Navbar />
            <main className="container mx-auto px-4 py-32">
                <div className="max-w-3xl mx-auto text-center">
                    <h1 className="text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-[#8f00ff] to-[#ffd700] bg-clip-text text-transparent">
                        Articles & Blog
                    </h1>
                    <div className="w-24 h-1.5 bg-gradient-to-r from-[#8f00ff] to-[#ffd700] rounded-full mb-8 mx-auto"></div>
                    <div className="p-12 bg-gray-100 dark:bg-gray-800 rounded-xl shadow-md flex flex-col items-center justify-center">
                        <div className="w-24 h-24 mb-6 opacity-50">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                            </svg>
                        </div>
                        <p className="text-xl font-medium text-gray-700 dark:text-gray-300 mb-4">
                            Page Under Construction
                        </p>
                        <p className="text-gray-600 dark:text-gray-400">
                            We're working hard to bring you amazing content soon.
                        </p>
                    </div>
                </div>
            </main>
            <ContactWidget />
            <Footer />
        </div>
    )
}

export default Articles
